import { animate, trigger, transition, style } from '@angular/animations';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { ClrModal } from '@clr/angular';

@Component({
  selector: 'ui-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('150ms ease-in-out', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class ModalComponent {
  @Input() public isOpened: boolean;
  @Input() public size = 'md';
  @Input() public modalTitle: string;
  @Input() public clrModalClosable = true;
  @Output() public isOpenedChange = new EventEmitter<boolean>();
  @ViewChild(ClrModal) modal: ClrModal;

  public onIsOpenedChanged($event: boolean) {
    this.isOpened = $event;
    this.isOpenedChange.emit(this.isOpened);
  }

  public open() {
    this.modal.open();
  }

  public close() {
    this.modal.close();
  }
}
